import React from 'react';
import { WifiIcon, BatteryMediumIcon, CloudIcon, BellIcon } from 'lucide-react';
export function SystemStatusBar() {
  const currentDate = new Date().toLocaleDateString('ko-KR', {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  });
  const currentTime = new Date().toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return <div className="w-full flex items-center justify-between py-4 px-6 border-b border-white/5 bg-[#0a0f1a]/50 backdrop-blur-md sticky top-0 z-20" data-id="element-328">
      <div className="flex items-center space-x-6" data-id="element-329">
        <div className="flex items-center space-x-2 text-cyan-400" data-id="element-330">
          <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse shadow-[0_0_8px_rgba(34,211,238,0.8)]" data-id="element-331" />
          <span className="text-xs font-medium tracking-widest uppercase opacity-80" data-id="element-332">
            연결됨
          </span>
        </div>
        <div className="h-4 w-px bg-white/10" data-id="element-333" />
        <div className="flex items-center space-x-2 text-slate-400" data-id="element-334">
          <CloudIcon className="w-4 h-4" data-id="element-335" />
          <span className="text-sm font-medium font-bold" data-id="element-336">외부온도: 12°C</span>
        </div>
      </div>

      <div className="flex items-center space-x-6" data-id="element-337">
        <div className="text-right" data-id="element-338">
          <div className="text-xs text-slate-500 font-mono uppercase tracking-wider" data-id="element-339">
            {currentDate}
          </div>
          <div className="text-sm text-slate-200 font-mono font-bold" data-id="element-340">
            {currentTime}
          </div>
        </div>

        <div className="flex items-center space-x-4 pl-6 border-l border-white/10" data-id="element-341">
          <button className="p-2 rounded-full hover:bg-white/5 transition-colors relative group" data-id="element-342">
            <BellIcon className="w-4 h-4 text-slate-400 group-hover:text-cyan-400 transition-colors" data-id="element-343" />
            <span className="absolute top-1.5 right-2 w-1.5 h-1.5 bg-red-500 rounded-full shadow-[0_0_5px_rgba(239,68,68,0.8)]" data-id="element-344" />
          </button>
          <div className="flex items-center space-x-1 text-emerald-400" data-id="element-345">
            <WifiIcon className="w-4 h-4" data-id="element-346" />
          </div>
          <div className="flex items-center space-x-1 text-slate-400" data-id="element-347">
            <BatteryMediumIcon className="w-4 h-4" data-id="element-348" />
            <span className="text-xs font-mono" data-id="element-349">98%</span>
          </div>
        </div>
      </div>
    </div>;
}